export const createUserSlice = (set) => ({
  userMobileNumber: "",
  mobileToken: "",
  userToken: "",
  refreshToken: "",
  userInfo: "",
  appVersion: 3029,
  storeMobileNumber: (mobileNo) => {
    set({
      userMobileNumber: mobileNo,
    });
  },
  storeMobileToken: (_mt) => set({ mobileToken: _mt }),
  storeUserTokens: (_ta, _tr) => set({ userToken: _ta, refreshToken: _tr }),
  storeUserInfo: (userData) => set({ userInfo: userData }),
  removeMobileNumber: () => set({ userMobileNumber: "" }),
  removeMobileToken: () => set({ mobileToken: "" }),
  clearAuth: () =>
    set({
      userMobileNumber: "",
      userToken: "",
      refreshToken: "",
      mobileToken: "",
      userInfo: "",
    }),
});
